import styles from './index.module.less';
const TitleWithBorder = ({text}:{text: string}) => {
    return <div className={styles.titleWithBorder}>{text}</div>
}
export default TitleWithBorder;